import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Modal, Row, Table } from 'react-bootstrap';
import { FaBookOpen } from 'react-icons/fa';
import { SiImessage } from 'react-icons/si';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../Pagination';
import ChatComponent from '../ChatComponent';
import DashboardLayout from './DashboardLayout ';
import Note from './Note';
import Slider from './Slider';

const EvergreenJobsApplication = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const userName = location.state?.userName;
    const userEmail = location.state?.userEmail;
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(6);
    const [totalPages, setTotalPages] = useState(0);
    const [sortedColumn, setSortedColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState(' ');
    const [filterApplications, setfilterApplications] = useState([]);
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(false); // State to manage loading  
    const [isLoading, setIsLoading] = useState(true);
    const [isGetUserData, setGetUserData] = useState(true);
    const [companyName, setCompanyName] = useState('');
    const [userData, setUserData] = useState({});
    const [isResumeBrief, setIsResumeBrief] = useState(false);
   

    const isLastPage = page === totalPages - 1;
    const isPageSizeDisabled = isLastPage;

    const handlePageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setPageSize(size);
        setPage(0); // Reset page when page size change
    };
    const handlePageClick = (data) => {
        const selectedPage = data.selected;
        setPage(selectedPage);

    };
    const [selectedRole, setSelectedRole] = useState('all');
    const handleRoleChange = (e) => {
        const newRole = e.target.value;
        setSelectedRole(newRole);
        fetchData(newRole); // Call fetchData function when the role changes
    };
    useEffect(() => {
        fetchData(selectedRole);
        fetchUserData(userEmail);
    }, [userEmail, selectedRole, page, pageSize, sortOrder, sortedColumn]);
    const fetchData = async (selectedRole) => {

        try {
            setLoading(true);
            const baseUrl = `${BASE_API_URL}/getEvergreenApplication?email=${userEmail}&page=${page}&pageSize=${pageSize}&sortOrder=${sortOrder}&sortedColumn=${sortedColumn}`;
            const url = selectedRole
                ? `${baseUrl}&selectedRole=${selectedRole}`
                : baseUrl;

            const response = await axios.get(url);
            if (selectedRole == 'all') {
                setApplications(response.data.content); // Adjust based on actual response structure
                setfilterApplications(response.data.content);
                setTotalPages(response.data.totalPages);
            } else {
                setfilterApplications(response.data.content);
                setTotalPages(response.data.totalPages);
            }
 
        } catch (error) {
           
        }
        finally {
            setLoading(false);
        }
    };

    const fetchUserData = async (userEmail) => {
        try {
            const response = await axios.get(`${BASE_API_URL}/getHRName?userEmail=${userEmail}`);
            setUserData(response.data);
        } catch (error) {
        }

    }
    useEffect(() => {
        // Get the userName and userId from location.state if available, otherwise from localStorage
        const storedUser = JSON.parse(localStorage.getItem('user'));  // Assuming 'user' is stored in localStorage

        setCompanyName(storedUser.companyName); // Set companyName from localStorage

    }, [location]);  // Re-run the effect when the location changes
    const [candidateName, setCandidateName] = useState();
    const [candidateEmail, setCandidateEmail] = useState();
    const [hrName, setHrName] = useState();
    const [hrEmail, setHrEmail] = useState();
    const fetchCandidateDetails = async () => {
        setGetUserData(true);
        const candidateNames = {};
        const candidateEmails = {};
        const hrNames = {};
        const hrEmails = {};
        for (const application of applications) {
            const res = await axios.get(`${BASE_API_URL}/getUserName`, {
                params: {
                    userId: application.candidateId
                }

            });
            candidateNames[application.candidateId] = res.data.userName;
            candidateEmails[application.candidateId] = res.data.userEmail;

            const response = await axios.get(`${BASE_API_URL}/getUserName`, {
                params: {
                    userId: application.hrId
                }
            });
            hrNames[application.hrId] = response.data.userName;
            hrEmails[application.hrId] = response.data.userEmail;
        }
        setCandidateName(candidateNames);
        setCandidateEmail(candidateEmails);
        setHrName(hrNames);
        setHrEmail(hrEmails);
        setGetUserData(false);
    }
    useEffect(() => {
        fetchCandidateDetails();
        fetchResumeTypes(applications);
    }, [applications]);

    const [resumeTypes, setResumeTypes] = useState({});
    const [fileNames, setfileNames] = useState({});
    const fetchResumeTypes = async (applications) => {
        setIsLoading(true);
        const types = {};
        const fileNames = {};
        for (const application of applications) {
            try {
                const response = await axios.get(`${BASE_API_URL}/getResumeByApplicationId?resumeId=${application.resumeId}`);
                types[application.resumeId] = response.data.fileType;
                fileNames[application.resumeId] = response.data.fileName;
            } catch (error) {
            }
        }
        setResumeTypes(types);
        setfileNames(fileNames);
        setIsLoading(false);
    };

    const renderResumeComponent = (resumeId, jobId) => {
        const fileType = resumeTypes[resumeId];
        const fileName = fileNames[resumeId];
        if (fileType === 'file') {
            return (
                <Button onClick={() => handleDownload(resumeId, fileName, jobId)}>Download</Button>

            );
        } else if (fileType === 'link') {
            return (
                <a href={fileName} target="_blank" rel="noopener noreferrer"
                    onClick={() => updateViewCount(resumeId, "link", jobId)}
                >Click here</a>
            );
        } else if (fileType === 'brief') {
            return (
                <Button onClick={() => {
                    updateViewCount(resumeId, "brief", jobId);
                    openPopup(fileName);
                }}>Open Brief</Button>
            );
        } else {
            return null; // Handle other file types as needed
        }
    };


    const updateViewCount = async (resumeId, action, jobId) => {
        try {
            await axios.post(`${BASE_API_URL}/resume-increment-view`, null, {
                params: {
                    resumeId: resumeId,
                    action: action,
                    companyName: companyName,
                    jobId: jobId,
                },
            });
        } catch (error) {
        }
    };
    const [showMessage, setShowMessage] = useState(false);
    const [showBriefSettings, setShowBriefSettings] = useState(false);
    const openPopup = (fileName) => {
        setShowMessage(fileName);
        setShowBriefSettings(!showBriefSettings);
    };

    const handleClick = async (candidateId) => {
        // navigate('/hr-dashboard/dream-applications/viewCandidateDetails', {
        //   state: {
        //     candidateId: candidateId,
        //     userName: userName,
        //     userEmail: userEmail,
        //     currentDreamAppPage: page,
        //     currentDreamAppPageSize: pageSize,
        //     dreamAppStatus: filterStatus,
        //     dreamAppFromDate: fromDate,
        //     dreamAppToDate: toDate,
        //     dreamAppSearch: search
        //   },
        // });
    };


    const handleDownload = async (resumeId, fileName, jobId) => {
        const action = "download"

        try {
            await axios.post(`${BASE_API_URL}/resume-increment-view`, null, {
                params: {
                    resumeId: resumeId,
                    action: action, // Action type
                    companyName: companyName,
                    jobId: jobId
                },
            });
            const response = await axios.get(`${BASE_API_URL}/downloadResume?resumeId=${resumeId}`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
        }
    };

    const updateStatus = async (applicationId, newStatus, hrId) => {
   
        try {
            const response = await axios.put(`${BASE_API_URL}/updateApplicationStatus?applicationId=${applicationId}&newStatus=${newStatus}&hrEmail=${userEmail}`);
            fetchData(selectedRole);
        } catch (error) {
        }
    };



    const [unreadMessages, setUnreadMessages] = useState([]); // State to track unread messages


    useEffect(() => {
        const fetchStatuses = async () => {

            const unread = {}; // Initialize unread messages state

            for (const application of applications) {
                try {

                    const countUnread = await fetchCountUnreadMessage(application.applicationId, userEmail);

                    unread[application.applicationId] = countUnread;

                } catch (error) {

                }
            }
            setUnreadMessages(unread); // Set unread messages state
        };
        fetchStatuses();
    }, [applications]);

    const fetchCountUnreadMessage = async (applicationId, userEmail) => {
        try {
            const response = await axios.get(
                `${BASE_API_URL}/fetchCountUnreadMessageForHRByApplicationId?applicationId=${applicationId}&userEmail=${userEmail}`
            );
            return response.data;
        } catch (error) {
        }
    };



    // Get unique job roles for filtering
    const jobRoles = [...new Set(applications.map(app => app.jobRole))];

    // State to track if the ChatComponent is open
    const [isChatOpen, setIsChatOpen] = useState(false);

    const [chatData, setChatData] = useState({
        applicationId: null,
        candidateId: null,
        hrId: null,
    });

    // Function to handle chat icon click
    const toggleChat = async (application) => {
        // Set the chat data for the clicked application
        // Mark messages as read
        axios.put(`${BASE_API_URL}/markCandidateMessagesAsRead?applicationId=${application.applicationId}`);
        const unread = {}; // Initialize unread messages state
        try {

            const countUnread = fetchCountUnreadMessage(application.applicationId);

            unread[application.applicationId] = countUnread;
            const response = await axios.get(`${BASE_API_URL}/getResumeByApplicationId?resumeId=${application.resumeId}`);

            // Assuming response.data is an object with the fileType field
            const fileType = response.data.fileType; // Correctly access fileType from response data


            if (fileType === 'brief') {
                setIsResumeBrief(true);  // Set the state to true if fileType is 'brief'
            } else {
                setIsResumeBrief(false); // Set the state to false if fileType is not 'brief'
            }

        } catch (error) {
        }
        setUnreadMessages(unread); // Set unread messages state
        setChatData({
            applicationId: application.applicationId,
            candidateId: application.candidateId,
            hrId: application.hrId,
        });
        // Toggle the visibility of the ChatComponent
        setIsChatOpen(!isChatOpen);
    };
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };
    // State to manage modal visibility and data to be passed
    const [isNoteOpen, setIsNoteOpen] = useState(false);
    const [selectedApplicationId, setSelectedApplicationId] = useState(null);
    const [selectedCandidateName, setSelectedCandidateName] = useState(null);

    // Handle opening the modal and setting the selected data
    const handleNoteClick = async (applicationId, candidateId, candidateName1, resumeId) => {
        setSelectedApplicationId(applicationId);
        const candidate = candidateName[candidateId];
        const response = await axios.get(`${BASE_API_URL}/getResumeByApplicationId?resumeId=${resumeId}`);
        console.log(response.data); // Log the entire response for debugging

        // Assuming response.data is an object with the fileType field
        const fileType = response.data.fileType; // Correctly access fileType from response data

        console.log(fileType); // Debugging output to see what fileType is returned

        if (fileType === 'brief') {
            setSelectedCandidateName('Ninja Applicant');
        } else {
            setSelectedCandidateName(candidateName1 || candidate);
        }

        setIsNoteOpen(true); // Show the modal
    };
    return (
        <DashboardLayout>
            <div className="main-content">
                <Col md={4}>
                    <h2 className='text-start' style={{ paddingLeft: '12px' }}>Evergreen Jobs Applications</h2>
                </Col>
                <Row className="mb-4 m-3">
                    <Col xs={12} md={6} lg={5}>
                        <div>
                            <label htmlFor="jobRoleFilter">Filter by Job Role:</label>
                            <select
                                id="jobRoleFilter"
                                className="form-select form-select fs-5" // Adjust the fs-* class as needed
                                style={{
                                    borderColor: '#6c5b7b',
                                    borderRadius: '6px',
                                    height: '40px', // Match the height of the select
                                    width: '100%', // Full width
                                    padding: '0 10px', // Add horizontal padding for text
                                }} value={selectedRole}
                                onChange={handleRoleChange} // Use the new handler here
                            >
                                <option value="all">All</option>
                                {jobRoles.map(role => (
                                    <option key={role} value={role}>{role}</option>
                                ))}
                            </select>
                        </div>
                    </Col>

                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <p>
                        <b>Action:(&nbsp;
                            <span className="circle gray"></span>Not Seen,&nbsp;
                            <span className="circle red"></span>Not Shortlisted,&nbsp;
                            <span className="circle green"></span>Shortlisted)
                        </b>
                    </p>
                </Row>
                <Row>
                    <Col md={6}>
                        <h2>
                            {applications.length === 0 ? (
                                <div style={{ textAlign: 'center' }}>There are no applicants for evergreen job application</div>
                            ) : (
                                <div className="text-start">Applicants of evergreen job applications</div>
                            )}
                        </h2>

                    </Col>
                </Row>
                {!loading && filterApplications.length > 0 && (
                    <div>
                        <Card body>
                            {/* <Card.Title>Light hoverable Table</Card.Title>

                            <p>
                                Add <code>.table-hover</code> to enable a hover state on table rows within a{" "}
                                <code>&lt;tbody&gt;</code>.
                            </p> */}
                            <div className="table-details-list table-wrapper">
                                <Table hover responsive >
                                    <thead>
                                        <tr style={{ textAlign: 'center' }}>
                                            <td>Job Id</td>
                                            <th>Job Role</th>
                                            <th>Candidate Name</th>
                                            <th>Candidate Email</th>
                                            <th>Resume ID</th>
                                            <th>Applied On</th>
                                            <th>Action</th>
                                            <th>Note</th>
                                            <th scope="col">Chat</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filterApplications.map((application) => (
                                            <tr key={application.id}>
                                                <td>{application.jobId}</td>
                                                <td>{application.jobRole}</td>
                                                <td> {isGetUserData ? 'Loading...' : application.candidateName ? application.candidateName : candidateName[application.candidateId]}</td>
                                                <td
                                                    onClick={() => handleClick(application.candidateId)}
                                                    style={{
                                                        color: 'purple',              // Dark grey text color
                                                        padding: '10px',            // Adding some padding
                                                        borderRadius: '5px',        // Rounded corners
                                                        cursor: 'pointer',           // Changing cursor to pointer on hover
                                                        textDecoration: 'underline'
                                                    }}
                                                >
                                                    {application.candidateEmail ? application.candidateEmail : candidateEmail[application.candidateId]}
                                                </td>

                                                <td>
                                                    {isLoading ? 'Loading...' : renderResumeComponent(application.resumeId, application.jobId)}
                                                </td>
                                                <td>{application.appliedOn}</td>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                    {application.applicationStatus === "Shortlisted" && hrEmail[application.hrId] !== userEmail ? (
                                                        <div>
                                                            Shortlisted by {hrName[application.hrId] || 'Unknown HR'} of {application.companyName}
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                            <Slider
                                                                initialStatus={application.applicationStatus}
                                                                onChangeStatus={(newStatus) => updateStatus(application.applicationId, newStatus, application.hrId)}
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                                <td
                                                    onClick={() => handleNoteClick(application.applicationId, application.candidateId, application.candidateName, application.resumeId)}  // Pass applicationId and candidateId
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <FaBookOpen />
                                                </td>
                                                <td >
                                                    {/* {application.applicationStatus === "Shortlisted" ? ( */}
                                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                                        {unreadMessages[application.applicationId] > 0 && (
                                                            <span
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-5px',
                                                                    right: '-15px',
                                                                    backgroundColor: 'red',
                                                                    color: 'white',
                                                                    borderRadius: '50%',
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '12px',
                                                                    fontWeight: 'bold',
                                                                    zIndex: 1, // Ensure notification badge is above SiImessage icon
                                                                }}
                                                            >
                                                                {unreadMessages[application.applicationId]}
                                                            </span>
                                                        )}
                                                        <SiImessage
                                                            size={25}
                                                            onClick={() => toggleChat(application)}
                                                            style={{ color: 'green', cursor: 'pointer' }}
                                                        />
                                                    </div>

                                                    {/* ) : (
                                                    <SiImessage
                                                        size={25}
                                                        style={{ color: 'grey', cursor: 'not-allowed' }}
                                                    />
                                                )
                                                } */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                            {/* Pagination */}

                            <Pagination
                                page={page}
                                pageSize={pageSize}
                                totalPages={totalPages}
                                handlePageSizeChange={handlePageSizeChange}
                                isPageSizeDisabled={isPageSizeDisabled}
                                handlePageClick={handlePageClick}
                            />
                        </Card>
                    </div>

                )}
                <Button variant='primary' onClick={handleBack} style={{ width: '100px', marginLeft: '12px' }}>Back</Button>

                {
                    showBriefSettings && (
                        <Modal show={showBriefSettings} onHide={() => setShowBriefSettings(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Brief Resume</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ overflowY: 'auto' }}>{showMessage}</Modal.Body>
                        </Modal>
                    )
                }
                {/* Conditionally render the Note component based on showModal */}
                {isNoteOpen && (
                    <Note
                        applicationId={selectedApplicationId}
                        userName={userName}
                        userEmail={userEmail}
                        candidateName={selectedCandidateName}
                        setIsNoteOpen={setIsNoteOpen}
                    />
                )}

                {/* Conditionally render the ChatComponent */}
                {
                    isChatOpen && (
                        <ChatComponent
                            applicationId={chatData.applicationId}
                            candidateId={chatData.candidateId}
                            hrId={chatData.hrId}
                            hrEmail={userEmail}
                            userType='HR'
                            setIsChatOpen={setIsChatOpen}
                            isResumeBrief={isResumeBrief}
                        />
                    )
                }
            </div>


        </DashboardLayout >
    );
};

export default EvergreenJobsApplication;
